import { FiChevronRight, FiHeart, FiPlay } from 'react-icons/fi';
import './FavoritesCard.scss';

interface FavoritesCardProps {
  count: number;
  loading?: boolean;
  onOpen: () => void;
  onPlay: () => void;
}

// Shortcut to your favourite tracks at the top of Playlists, like "Liked songs" in most
// music apps (same card as the mobile app): heart tile, count, and a play button.
const FavoritesCard = ({ count, loading, onOpen, onPlay }: FavoritesCardProps) => (
  <div className="favoritesCard" role="button" tabIndex={0} onClick={onOpen}
    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpen(); } }}
    aria-label={`Favourite tracks, ${count} tracks`}
  >
    <span className="favoritesCard__tile" aria-hidden="true">
      <FiHeart />
    </span>
    <span className="favoritesCard__text">
      <span className="favoritesCard__title">Favourite tracks</span>
      <span className="favoritesCard__count">
        {loading && count === 0 ? 'Loading…' : count === 0 ? 'Click the ♡ on any track to save it' : `${count} ${count === 1 ? 'track' : 'tracks'}`}
      </span>
    </span>
    {count > 0 ? (
      // Its own button, so playing does not also open the list.
      <button
        type="button"
        className="favoritesCard__play"
        onClick={(e) => { e.stopPropagation(); onPlay(); }}
        aria-label="Play favourite tracks"
      >
        <FiPlay />
      </button>
    ) : (
      <FiChevronRight className="favoritesCard__chevron" aria-hidden />
    )}
  </div>
);

export default FavoritesCard;
